import { createSlice } from "@reduxjs/toolkit";
import {
  addWebinarData,
  authForgotPassword,
  authSignin,
  contactUs,
  createCoachSpeakerImageData,
  deleteWebinar,
  fetchBootCamps,
  fetchCoachBookedWebinar,
  fetchCoachCategories,
  fetchCoachWebinar,
  fetchWebinarData,
  getAllPublicWorkshop,
  fetchWorkshop,
  handleCoachSignUp,
  handlePurchaseBootCamp,
  handlePurchasePlanCoach,
  handlePurchasePlanData,
  handleWaitListBootCamp,
  registerToday,
  setPassword,
  shareOtp,
  updateSpeakerImageData,
  updateWebinarData,
  createCoachWorkshopSpeakerImageData,
  addCoachWorkshopData,
  deleteWorkShop,
  updateCoachWorkshopData,
  updateCoachWorkshopSpeakerImageData,
  getAllEBooksListCoach,
  getAllCoachWorkshopByCoachId,
  getCoachDataByID,
  getCoachEBookByID,
  fetchNuterras,
  reserveSpot,
  fetchWorkshopBookings,
  toggleWorkShopStatus,
  createCoachPassword,
} from "../actions/authAction";
import { getAllWorkshopPublicAPI } from "../../../../routes/apiurls";

const initialState = {
  isLoading: false,
  categoryList: [],
  subscriptionPlan: [],
  bootcampList: [],
  allWebinarList: [],
  nuterraList: [],
  webinarList: [],
  eventData: {},
  workshopList: [],
  tabs: [
    {
      label: "Webinar",
      value: "webinar",
    },
    {
      label: "Webinar Booking",
      value: "Webinar_Booking",
    },
    {
      label: "Workshop",
      value: "work_shop",
    },
    {
      label: "Workshop Booking",
      value: "workshop_bookings",
    },
  ],
  tableHeaders: {
    Webinar_Booking: [
      "#",
      "Title",
      "Join Date",
      "Phone Number",
      "Role",
      "Action",
    ],
    webinar: ["#", "Webinar Name", "Start Date", "Duration", "Action"],
    work_shop: ["#", "Workshop Name", "Start Date", "Duration", "Status", "Action"],
    workshop_bookings: [
      "#",
      "Title",
      "Name",
      "Email",
      "Action",
    ],
  },
  getAllEBookList: [],
  getAllCoachWorkshop: [],
  getCoachDataById: {},
  coachEbook: [],
};

const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  extraReducers: (builder) => {
    // register-today
    builder.addCase(registerToday.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(registerToday.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(registerToday.rejected, (state, action) => {
      state.isLoading = false;
    });
    // contact-us
    builder.addCase(contactUs.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(contactUs.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(contactUs.rejected, (state, action) => {
      state.isLoading = false;
    });
    // auth-sign-in
    builder.addCase(authSignin.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(authSignin.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(authSignin.rejected, (state, action) => {
      state.isLoading = false;
    });
    // authForgotPassword
    builder.addCase(authForgotPassword.pending, (state, action) => {
      // state.isLoading = true;
    });
    builder.addCase(authForgotPassword.fulfilled, (state, action) => {
      // state.isLoading = false;
    });
    builder.addCase(authForgotPassword.rejected, (state, action) => {
      // state.isLoading = false;
    });
    // share-otp
    builder.addCase(shareOtp.pending, (state, action) => {
      // state.isLoading = true;
    });
    builder.addCase(shareOtp.fulfilled, (state, action) => {
      // state.isLoading = false;
    });
    builder.addCase(shareOtp.rejected, (state, action) => {
      // state.isLoading = false;
    });
    // set-password
    builder.addCase(setPassword.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(setPassword.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(setPassword.rejected, (state, action) => {
      state.isLoading = false;
    });
    // get-coach-categories
    builder.addCase(fetchCoachCategories.pending, (state, action) => {
      // state.isLoading = true;
    });
    builder.addCase(fetchCoachCategories.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.categoryList = data || [];
      // state.isLoading = false;
    });
    builder.addCase(fetchCoachCategories.rejected, (state, action) => {
      // state.isLoading = false;
    });

    // handleCoachSignUp
    builder.addCase(handleCoachSignUp.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(handleCoachSignUp.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(handleCoachSignUp.rejected, (state, action) => {
      state.isLoading = false;
    });

    // handlePurchasePlanData
    builder.addCase(handlePurchasePlanData.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(handlePurchasePlanData.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.subscriptionPlan = data ?? [];
      state.isLoading = false;
    });
    builder.addCase(handlePurchasePlanData.rejected, (state, action) => {
      state.isLoading = false;
    });

    // handlePurchasePlanCoach
    builder.addCase(handlePurchasePlanCoach.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(handlePurchasePlanCoach.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(handlePurchasePlanCoach.rejected, (state, action) => {
      state.isLoading = false;
    });

    // fetchBootCamps
    builder.addCase(fetchBootCamps.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchBootCamps.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.bootcampList = data ?? [];
      state.isLoading = false;
    });
    builder.addCase(fetchBootCamps.rejected, (state, action) => {
      state.isLoading = false;
    });
    // fetchCoachWebinar
    builder.addCase(fetchCoachWebinar.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchCoachWebinar.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.eventData = {
        ...state.eventData,
        webinar: data || [],
      };
      state.isLoading = false;
    });
    builder.addCase(fetchCoachWebinar.rejected, (state, action) => {
      state.isLoading = false;
    });
    // fetchCoachBookedWebinar
    builder.addCase(fetchCoachBookedWebinar.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchCoachBookedWebinar.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.eventData = {
        ...state.eventData,
        Webinar_Booking: data || [],
      };
      state.isLoading = false;
    });
    builder.addCase(fetchCoachBookedWebinar.rejected, (state, action) => {
      state.isLoading = false;
    });

    // handlePurchaseBootCamp
    builder.addCase(handlePurchaseBootCamp.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(handlePurchaseBootCamp.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(handlePurchaseBootCamp.rejected, (state, action) => {
      state.isLoading = false;
    });

    // handleWaitListBootCamp
    builder.addCase(handleWaitListBootCamp.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(handleWaitListBootCamp.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(handleWaitListBootCamp.rejected, (state, action) => {
      state.isLoading = false;
    });

    // fetchWebinarData
    builder.addCase(fetchWebinarData.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchWebinarData.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.allWebinarList = data ?? [];
      state.isLoading = false;
    });
    builder.addCase(fetchWebinarData.rejected, (state, action) => {
      state.isLoading = false;
    });
    // fetchNuterras
    builder.addCase(fetchNuterras.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchNuterras.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.nuterraList = data ?? [];
      state.isLoading = false;
    });
    builder.addCase(fetchNuterras.rejected, (state, action) => {
      state.isLoading = false;
    });

    // addWebinarData
    builder.addCase(addWebinarData.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(addWebinarData.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(addWebinarData.rejected, (state, action) => {
      state.isLoading = false;
    });

    // createCoachSpeakerImageData
    builder.addCase(createCoachSpeakerImageData.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(createCoachSpeakerImageData.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(createCoachSpeakerImageData.rejected, (state, action) => {
      state.isLoading = false;
    });

    // deleteWebinar
    builder.addCase(deleteWebinar.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(deleteWebinar.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(deleteWebinar.rejected, (state, action) => {
      state.isLoading = false;
    });

    // updateWebinarData
    builder.addCase(updateWebinarData.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(updateWebinarData.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(updateWebinarData.rejected, (state, action) => {
      state.isLoading = false;
    });

    // updateSpeakerImageData
    builder.addCase(updateSpeakerImageData.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(updateSpeakerImageData.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(updateSpeakerImageData.rejected, (state, action) => {
      state.isLoading = false;
    });

    // getAllPublicWorkshop
    builder.addCase(getAllPublicWorkshop.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getAllPublicWorkshop.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.workshopList = data ?? [];
      state.isLoading = false;
    });
    builder.addCase(getAllPublicWorkshop.rejected, (state, action) => {
      state.isLoading = false;
    });
    // fetch-workshop
    builder.addCase(fetchWorkshop.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchWorkshop.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.eventData = {
        ...state.eventData,
        work_shop: data || [],
      };
      state.isLoading = false;
    });
    builder.addCase(fetchWorkshop.rejected, (state, action) => {
      state.isLoading = false;
    });
    // fetch-workshop
    builder.addCase(fetchWorkshopBookings.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchWorkshopBookings.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.eventData = {
        ...state.eventData,
        workshop_bookings: data || [],
      };
      state.isLoading = false;
    });
    builder.addCase(fetchWorkshopBookings.rejected, (state, action) => {
      state.isLoading = false;
    });

    // getAllEBooksListCoach
    builder.addCase(getAllEBooksListCoach.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getAllEBooksListCoach.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.getAllEBookList = data || [];
      state.isLoading = false;
    });
    builder.addCase(getAllEBooksListCoach.rejected, (state, action) => {
      state.isLoading = false;
    });

    // getAllCoachWorkshopByCoachId
    builder.addCase(getAllCoachWorkshopByCoachId.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getAllCoachWorkshopByCoachId.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.getAllCoachWorkshop = data || [];
      state.isLoading = false;
    });
    builder.addCase(getAllCoachWorkshopByCoachId.rejected, (state, action) => {
      state.isLoading = false;
    });

    // getCoachDataByID
    builder.addCase(getCoachDataByID.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getCoachDataByID.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.getCoachDataById = data || {};
      state.isLoading = false;
    });
    builder.addCase(getCoachDataByID.rejected, (state, action) => {
      state.isLoading = false;
    });

    // getCoachEBookByID
    builder.addCase(getCoachEBookByID.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getCoachEBookByID.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.coachEbook = data || [];
      state.isLoading = false;
    });
    builder.addCase(getCoachEBookByID.rejected, (state, action) => {
      state.isLoading = false;
    });

    // createCoachWorkshopSpeakerImageData
    builder.addCase(
      createCoachWorkshopSpeakerImageData.pending,
      (state, action) => {
        state.isLoading = true;
      }
    );
    builder.addCase(
      createCoachWorkshopSpeakerImageData.fulfilled,
      (state, action) => {
        state.isLoading = false;
      }
    );
    builder.addCase(
      createCoachWorkshopSpeakerImageData.rejected,
      (state, action) => {
        state.isLoading = false;
      }
    );

    // addCoachWorkshopData
    builder.addCase(addCoachWorkshopData.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(addCoachWorkshopData.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(addCoachWorkshopData.rejected, (state, action) => {
      state.isLoading = false;
    });

    // deleteWorkShop
    builder.addCase(deleteWorkShop.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(deleteWorkShop.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(deleteWorkShop.rejected, (state, action) => {
      state.isLoading = false;
    });

    // updateCoachWorkshopData
    builder.addCase(updateCoachWorkshopData.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(updateCoachWorkshopData.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(updateCoachWorkshopData.rejected, (state, action) => {
      state.isLoading = false;
    });

    // updateCoachWorkshopSpeakerImageData
    builder.addCase(
      updateCoachWorkshopSpeakerImageData.pending,
      (state, action) => {
        state.isLoading = true;
      }
    );
    builder.addCase(
      updateCoachWorkshopSpeakerImageData.fulfilled,
      (state, action) => {
        state.isLoading = false;
      }
    );
    builder.addCase(
      updateCoachWorkshopSpeakerImageData.rejected,
      (state, action) => {
        state.isLoading = false;
      }
    );

    // reserveSpot
    builder.addCase(reserveSpot.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(reserveSpot.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(reserveSpot.rejected, (state, action) => {
      state.isLoading = false;
    });
    // toggleWorkShopStatus
    builder.addCase(toggleWorkShopStatus.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(toggleWorkShopStatus.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(toggleWorkShopStatus.rejected, (state, action) => {
      state.isLoading = false;
    });

    // createCoachPassword
    builder.addCase(createCoachPassword.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(createCoachPassword.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(createCoachPassword.rejected, (state, action) => {
      state.isLoading = false;
    });
  },
});

export default authSlice.reducer;
